import React from "react";

const DraggableContext = React.createContext({
  notifyFormOpen: () => null,
  notifyFormClosed: () => null,
});

export const DraggableContextProvider = DraggableContext.Provider;
export const DraggableContextConsumer = DraggableContext.Consumer;
export const useDraggableContext = () => React.useContext(DraggableContext);
export default DraggableContext;
